"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const settlementQuery_1 = require("../../../../queries/settlementQuery");
const Root_1 = require("../../../../router/Root");
const zustandStore_1 = require("../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const createCard_1 = require("../../../organisms/createCard");
const walletDetails_1 = require("../component/walletDetails");
const cardUtils_1 = require("../myCardsListView/cardUtils");
const ViewReceiptImageModal = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../modals/viewReceiptImage'))));
const ViewReceiptAside = () => {
    const asideTitle = 'Receipt';
    const { setNotification, isViewReceiptAsideOpen, setIsViewReceiptsAsideOpen, settlement, settlements, settlementList, setSettlementsData, setSettlements, setIsReceiptUploadRemove, settlementFilters, } = (0, zustandStore_1.useZustand)(state => ({
        setNotification: state.setNotification,
        isViewReceiptAsideOpen: state.aside.viewReceiptAside.isOpen,
        settlement: state.aside.viewReceiptAside.settlement,
        setIsViewReceiptsAsideOpen: state.setIsViewReceiptsAsideOpen,
        settlements: state.wallet.settlements,
        settlementList: state.settlement.settlements,
        setSettlementsData: state.setSettlementsData,
        setSettlements: state.setSettlements,
        settlementFilters: state.settlement.filters,
        setIsReceiptUploadRemove: state.setIsReceiptUploadRemove,
    }));
    const { data: receiptInfo } = (0, react_query_1.useQuery)((0, settlementQuery_1.getReceiptInfoQuery)(settlement?.id || ''));
    const [isUploading, setIsUploading] = (0, react_1.useState)(false);
    const [uploadState, setUploadState] = (0, react_1.useState)('INITIAL');
    const [fileName, setFileName] = (0, react_1.useState)('');
    const [isOpenImageModal, setIsOpenImageModal] = (0, react_1.useState)(false);
    const uploadReceipt = (0, settlementQuery_1.useUploadReceipt)();
    const removeReceipt = (0, settlementQuery_1.useRemoveReceiptQuery)();
    const textList = ['Image or PDF file formats supported', 'File size should be less than 10 MB'];
    const receiptName = receiptInfo?.[settlement?.id || '']?.name || '';
    (0, react_1.useEffect)(() => {
        if (uploadState !== 'ERROR') {
            if (receiptInfo && receiptName) {
                setUploadState('UPLOADED');
                setFileName(receiptName);
            }
            else {
                setUploadState('INITIAL');
                setFileName('');
            }
        }
    }, [receiptInfo, settlement?.id, fileName, uploadState]);
    const onFileChange = (event) => {
        if (event.target instanceof HTMLInputElement && event.target.files && event.target.files[0]) {
            const fileData = event.target.files[0];
            const isValidFileSize = (0, cardUtils_1.validateFileSize)({
                file: fileData,
                maxSizeMB: 10,
            });
            const isValidFileType = (0, cardUtils_1.validateFileType)({
                file: fileData,
            });
            if (!isValidFileSize || !isValidFileType) {
                setUploadState('ERROR');
                if (receiptInfo && receiptName) {
                    setFileName(receiptName);
                }
                return;
            }
            setIsUploading(true);
            const uploadUrl = `/rest/payments/settlements/${settlement?.id}/receipt`;
            uploadReceipt.mutate({
                file: event.target.files[0],
                url: uploadUrl,
                settlementId: settlement?.id || '',
                virtualCardId: settlement?.cardId || '',
            }, {
                onSuccess: (id) => {
                    void Root_1.queryClient.invalidateQueries({
                        queryKey: [settlementQuery_1.SettlementKeys.getReceiptInfo, settlement?.id || ''],
                    });
                    void Root_1.queryClient.invalidateQueries({
                        queryKey: [settlementQuery_1.SettlementKeys.getSettlementListForWallet, settlement?.cardId || ''],
                    });
                    void Root_1.queryClient.invalidateQueries({
                        queryKey: [settlementQuery_1.SettlementKeys.getSettlementList, settlementFilters.month, settlementFilters.year],
                    });
                    if (settlement) {
                        const updatedSettlements = settlements.map(obj => {
                            if (obj?.id === settlement.id) {
                                return { ...obj, receiptId: id };
                            }
                            return obj;
                        });
                        setSettlementsData(updatedSettlements);
                        const updatedSettlementList = settlementList.map(obj => {
                            if (obj?.id === settlement.id) {
                                return { ...obj, receiptId: id };
                            }
                            return obj;
                        });
                        setSettlements(updatedSettlementList);
                        setIsReceiptUploadRemove(true);
                    }
                    setUploadState('UPLOADED');
                    setFileName(fileData.name);
                },
                onError: () => {
                    setFileName('');
                    setUploadState('ERROR');
                },
                onSettled: () => {
                    setIsUploading(false);
                },
            });
        }
        else {
            return;
        }
    };
    const onCloseModal = () => {
        setIsOpenImageModal(false);
    };
    const onOpenModal = () => {
        setIsOpenImageModal(true);
    };
    const removeReceiptFn = () => {
        removeReceipt.mutate({ settlementId: settlement?.id || '', virtualCardId: settlement?.cardId || '' }, {
            onSuccess: () => {
                void Root_1.queryClient.invalidateQueries({
                    queryKey: [settlementQuery_1.SettlementKeys.getReceiptInfo, settlement?.id || ''],
                });
                void Root_1.queryClient.invalidateQueries({
                    queryKey: [settlementQuery_1.SettlementKeys.getSettlementListForWallet, settlement?.cardId || ''],
                });
                void Root_1.queryClient.invalidateQueries({
                    queryKey: [settlementQuery_1.SettlementKeys.getSettlementList, settlementFilters.month, settlementFilters.year],
                });
                if (settlement) {
                    const updatedSettlements = settlements.map(obj => {
                        if (obj?.id === settlement.id) {
                            return { ...obj, receiptId: undefined };
                        }
                        return obj;
                    });
                    setSettlementsData(updatedSettlements);
                    const updatedSettlementList = settlementList.map(obj => {
                        if (obj?.id === settlement.id) {
                            return { ...obj, receiptId: undefined };
                        }
                        return obj;
                    });
                    setSettlements(updatedSettlementList);
                    setIsReceiptUploadRemove(true);
                }
                setFileName('');
                setUploadState('INITIAL');
                setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: strings_1.walletStrings.RECEIPT_REMOVED_SUCCESS,
                    },
                ]);
            },
            onError: () => {
                setUploadState('UPLOADED');
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: strings_1.walletStrings.RECEIPT_REMOVED_ERROR,
                    },
                ]);
            },
        });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Drawer, { id: 'viewReceipt', title: asideTitle, open: isViewReceiptAsideOpen, onClose: () => {
                    setFileName('');
                    setUploadState('INITIAL');
                    setIsViewReceiptsAsideOpen(false);
                }, anchor: 'right', sx: { width: 320 }, ModalProps: { hideBackdrop: !isViewReceiptAsideOpen }, "data-testid": "view-receipt", children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h6", children: (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { size: 11, children: asideTitle }), (0, jsx_runtime_1.jsx)(material_1.Grid, { size: 1, children: (0, jsx_runtime_1.jsx)(Close_1.default, { "ts-variant": "closeIcon", onClick: () => {
                                            setFileName('');
                                            setUploadState('INITIAL');
                                            setIsViewReceiptsAsideOpen(false);
                                        } }) })] }) }), (0, jsx_runtime_1.jsxs)("form", { className: "form-wrapper", children: [(0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { padding: '10px' }, children: [(0, jsx_runtime_1.jsx)(createCard_1.StyledFormLabel, { children: strings_1.walletStrings.UPLOAD_RECEIPT_TEXT }), (0, jsx_runtime_1.jsx)(material_1.OutlinedInput, { inputProps: { accept: 'image/*,application/pdf' }, id: 'uploadReceipt', name: 'uploadReceipt', required: true, type: 'file', onChange: onFileChange }), (0, jsx_runtime_1.jsx)(walletDetails_1.StyledUploadBtnLabel, { htmlFor: "uploadReceipt", "ts-variant": isUploading ? 'uploading' : '', children: isUploading ? '' : fileName || '' }), uploadState === 'UPLOADED' && ((0, jsx_runtime_1.jsx)(walletDetails_1.StyledSuccessTypo, { component: 'span', sx: { fontWeight: 'bold' }, children: strings_1.walletStrings.RECEIPT_UPLOAD_SUCCESS })), uploadState === 'ERROR' && ((0, jsx_runtime_1.jsxs)(walletDetails_1.StyledErrorTypo, { "ts-variant": uploadState === strings_1.notificationStrings.ERROR.toUpperCase() ? 'error' : '', children: [(0, jsx_runtime_1.jsx)(Warning_1.default, { sx: { fontSize: '16px' } }), " ", strings_1.walletStrings.RECEIPT_UPLOAD_ERROR] })), (uploadState === 'INITIAL' || uploadState === 'ERROR') && ((0, jsx_runtime_1.jsx)(material_1.List, { sx: { pt: 0.5, pr: 1, pb: 0, pl: 1.5 }, children: textList.map(text => ((0, jsx_runtime_1.jsx)(walletDetails_1.StyledListItem, { "ts-variant": uploadState === strings_1.notificationStrings.ERROR.toUpperCase() ? 'error' : '', children: text }, text))) }))] }), (uploadState === 'UPLOADED' || (receiptInfo && receiptInfo[settlement?.id || '']?.name)) && ((0, jsx_runtime_1.jsxs)(material_1.Stack, { sx: {
                                    mt: 3,
                                }, children: [(0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "viewReceipt-btn", color: uiConstants_1.UI_BUTTON_PRIMARY, style: { marginBottom: '10px' }, onClick: onOpenModal, label: strings_1.walletStrings.VIEW_RECEIPT_TEXT }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "removeReceipt-btn", color: uiConstants_1.UI_BUTTON_SECONDARY, style: { marginBottom: '10px' }, onClick: removeReceiptFn, label: strings_1.walletStrings.REMOVE_RECEIPT_TEXT })] }))] })] }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(ViewReceiptImageModal, { open: isOpenImageModal, receipt: receiptInfo?.[settlement?.id || ''], onClose: onCloseModal }) })] }));
};
exports.default = ViewReceiptAside;
